// export const homePath = "/";
// export const error404 = "*";
// export const companyPath = "/edit";
// export const companyEdit = `${companyPath}/:id`;

// export const test = {
//     path = "/";

// }
const companyPath = 'firma';
const myAccountPath = 'konto';

export const UrlPath = {
  Frontpage : {
      Home: "/"
  },
    Account: {
    Company : `/${companyPath}`,
    CompanyEdit: `/${companyPath}/:id`,
    LogDetails: `/${companyPath}/:id/logg/:changeLogId`,
    CompanyEditElements: `/${companyPath}/:id/:element`,
    Statistics: `/${companyPath}/:id/statistikk/`,
    Products: `/${companyPath}/:id/produkter/`,
    InfoSite: `/${companyPath}/:id/infoside/`,
    Actions: {
        Details: "detaljer",
        PhoneNumbers: "kontakter",
        Products: "produkter",
        Invoices: "faktura",
        Logg: "logg",
        AccessManagement: "endringstilgang",
        Links: "lenker",
        Industries: "bransjer",
        Statistics: "statistikk",
        OpeningHours: "apningstider",
        InfoSite: "infoside"
    }
  },
  MyAccount: {
    Home: `/${myAccountPath}`,
    AddCompany: `/${myAccountPath}/leggtilbedrift`
  }
}